import { useTranslation } from "react-i18next";
import { Button } from "../../../components";
import { TransactionDetailProps } from "./TransactionDetailProps";
import { formatDate, formatTime } from "../../history.utils";
import useWindowDimensions, { CurrentScreen } from "../../../../../hooks/use-window-dimensions";
import styles from "../customer-transaction-history-detail.module.scss";
import { TransactionReceiptHeader } from "./TransactionReceiptHeader";
import { formatCurrency, handleCopy } from "../../../../../utils";
import { CopyIcon } from "../../../../../assets/icons";

export const ServiceRequestTransactionDetail = ({
  transaction,
}: TransactionDetailProps) => {
  const { t } = useTranslation();
  const currentScreen: CurrentScreen = useWindowDimensions();

  return (
    <>

      <div className={styles.detailsCard}>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("common.labels.serviceRequest")}</span>
          <span className={styles.detailValue}>{transaction.serviceRequestDetails?.name}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("common.labels.amountPaid")}</span>
          <span className={styles.detailValue}>{formatCurrency(transaction.amount?.amount, { currency: transaction?.amount?.currency })}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("common.labels.paymentChannel")}</span>
          <span className={styles.detailValue}>{transaction.serviceRequestDetails?.paymentChannel}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("common.labels.date")}</span>
          <span className={styles.detailValue}>{formatDate(transaction.createdAt)}, {formatTime(transaction.createdAt).toLocaleLowerCase()}</span>
        </div>
      </div>

      <div className={styles.footer}>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("history.web.transactionId")}</span>
          <div className={styles.copyContainer}>
            <span className={styles.detailValue}>{transaction.reference}</span>
            <CopyIcon onClick={() => handleCopy(transaction.reference)
            } className={styles.copyBtn} />
          </div>
        </div>
      </div>
    </>
  );
};
